export enum SlideFormat {
  FULL_DETAILS = "Full Details",
  LESS_DETAILS = "Less Details",
}
